var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsaveSmallLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 492",
    d: "M32 14.999a4.76 4.76 0 00-1.857-3.831 4.293 4.293 0 01-2.292 1.951 4.17 4.17 0 002.334-3.718 4.237 4.237 0 00-4.3-4.182 2.839 2.839 0 00-.435.022 9.236 9.236 0 01.815 3.541H26.2a10.313 10.313 0 00-20.4 0h-.068a8.846 8.846 0 01.752-3.5A7.3 7.3 0 000 12.594a7.51 7.51 0 007.611 7.405h19.355v-.007A5.065 5.065 0 0032 14.999z",
    fill: "#17bed0",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 248",
    d: "M17.795 5.301a.5.5 0 01.5.5v4.5h2.794a.5.5 0 01.352.852l-4.792 4.794a.5.5 0 01-.708 0l-4.792-4.794a.5.5 0 01.354-.852h2.792v-4.5a.5.5 0 01.5-.5z",
    fill: "#fff"
  })));
}
export default SvgPsaveSmallLogo;